export default "__VITE_ASSET__B8J2HAtm__"